import { customAlphabet } from "nanoid";

const SLUG_ALPHABET = "abcdefghijklmnopqrstuvwxyz0123456789";
const SLUG_RE = /^[a-z0-9]+$/i;
const slugGen = customAlphabet(SLUG_ALPHABET, 6);

export function parseLobbyIdFromPath(pathname: string): string | null {
  // Match exactly /p/<slug> with optional trailing slash and ignore extra segments.
  // Only allow / or end-of-string after the slug; ? and # are not valid terminators.
  const m = pathname.match(/^\/p\/([^/?#]+)(?:\/|$)/);
  if (!m) return null;
  const slug = m[1]!;
  if (!SLUG_RE.test(slug)) return null;
  return slug;
}

export function generateLobbyId(): string {
  return slugGen();
}
